// Copyright (C) 2021 Bystronic Laser AG

export enum LaserOutputAndScrapTimelineChartMode {
  NonStackedLines = 'NonStackedLines',
  StackedColumns = 'StackedColumns',
  RawMaterialUtilization = 'RawMaterialUtilization',
}
